import { render, staticRenderFns } from "./stockNoteModal.vue?vue&type=template&id=03dd2fe8&"
import script from "./stockNoteModal.vue?vue&type=script&lang=js&"
export * from "./stockNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports